import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Popover, units } from '@ha/dsl';

import { OverlayProps } from '../types';
import { PopoverActions } from './Popover/PopoverActions';

const useStyles = makeStyles()(theme => ({
  popoverRoot: {
    padding: units.yx(0, 1),
    [theme.breakpoints.up('sm')]: {
      padding: 0,
    },
    maxWidth: '624px',
  },
}));

const DatePickerPopover: React.FC<
  Omit<OverlayProps, 'onFieldFocusChange'>
> = props => {
  const {
    classes: { popoverRoot },
  } = useStyles();
  const {
    containerRef,
    children,
    onOverlayClose,
    onOverlayExit,
    open,
    OverlayTitle,
    OverlayActions,
    OverlayInfo,
  } = props;

  return (
    <Popover
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      anchorEl={containerRef.current}
      data-test-locator="DatePicker / Overlay / Popover"
      onClose={onOverlayClose}
      open={open}
      PaperProps={{
        classes: { root: popoverRoot },
      }}
      transitionDuration={0}
      marginThreshold={4}
      TransitionProps={{
        onExit: onOverlayExit,
      }}
    >
      {OverlayTitle}
      {children}
      {OverlayInfo}
      <PopoverActions>{OverlayActions}</PopoverActions>
    </Popover>
  );
};

export { DatePickerPopover };
